import { render } from "./ClientOffers.vue?vue&type=template&id=f1f29c38&scoped=true"
import script from "./ClientOffers.vue?vue&type=script&lang=js"
export * from "./ClientOffers.vue?vue&type=script&lang=js"

import "./ClientOffers.vue?vue&type=style&index=0&id=f1f29c38&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f29c38"]])

export default __exports__